export default {
    type: 'service-service-categories',
    aliases: {
        camel: 'serviceServiceCategories',
        singular: 'Service service category',
        plural: 'Service service categories',
        lowerSingular: 'service service category',
        lowerPlural: 'service service categories',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
